var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.001,
    height: 25,
    viewBox: "0 0 28.001 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    transform: "translate(-2.215 -3.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M6.318,6.876h20a5.484,5.484,0,0,1,.7.044,4.126,4.126,0,0,0-4.845-3.473L5.724,6.255H5.705A4.126,4.126,0,0,0,3.138,7.888a5.473,5.473,0,0,1,3.18-1.012Z",
    transform: "translate(-0.103)",
    fill: "#FFE3D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M26.216,9h-20a4,4,0,0,0-4,4V25a4,4,0,0,0,4,4h20a4,4,0,0,0,4-4V13a4,4,0,0,0-4-4ZM23.247,21a2,2,0,1,1,2-2A2,2,0,0,1,23.247,21Z",
    transform: "translate(0 -0.625)",
    fill: "#FFE3D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M2.25,16.9V10.684A4.093,4.093,0,0,1,5.6,6.567,27.111,27.111,0,0,1,10,6.152s1.437,1,.25,1a.773.773,0,1,0,0,1.532c1.157,0,0,1.469,0,1.469L5.594,15.434Z",
    transform: "translate(-0.004 -0.308)",
    fill: "#FFE3D9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLight);
export default __webpack_public_path__ + "static/media/wallet--light.60fbc32be452b431d3b087fbeb9e5af9.svg";
export { ForwardRef as ReactComponent };